import { render } from "./Navigation.vue?vue&type=template&id=66f8dd5c"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\code repo\\iebrewers.org\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__